import Api from './Api';

const END_POINT = "solicitud";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}`, request);
  },
  async get_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}-list-paginated`, request);
  },
  async store(sale) {
    // console.log("sales: ", sale);
    return await Api.post(`${END_POINT}`, sale);
  },

  get_orders(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/orders`, request);
  },

  async saveSolicitud(sale) {
    return await Api.post(`${END_POINT}/save-solicitud`, sale);
  },
  async getLastOrderCodeSolicitud() {
    return await Api.get(`${END_POINT}/the-last-order-code`);
  },
  async getSolicitudVoucher (solicitud_id){
    return await Api.get(`${END_POINT}/solicitud-voucher/${solicitud_id}`);
  },
  async cancelSolicitud(item) {
    return await Api.post(`${END_POINT}/cancel`, item);
  }

};
